<div class="title">Rent Reporting</div>

<div class="middle">
  <img src="assets/images/GRA_RentReporting.svg" alt="Rent Reporting">
  <div>Boost your credit score by reporting your rent payments</div>
</div>

<a class="btn btn-link" routerLink="/rent-reporting">View Now</a>
